import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {BdListLink, MindmapListLink, NotepadListLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const OtherToolsGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.other_tools',
    links: [
        NotepadListLink(context),
        MindmapListLink(context),
        BdListLink(context)
    ],
    icon: 'navigation-group__other-tools',
});